import Heimdall, { images } from '@ecs/heimdall';
import { menusPersonalLoan, menusCreditCard } from '../../utils';

const REDIRECT_URL = `redirectUrl=${process.env.ECS_WEB_CREDIT_AREA_PATH}`;

const menusHome = pages => {
  if (pages) {
    return [
      {
        url: '/ecred',
        key: 'ir-para-home',
        label: 'Ir para home'
      }
    ];
  }
  return [];
};

export default function(pages) {
  Heimdall(
    {
      product: 'ecred',
      menus: [
        ...menusHome(pages),
        {
          url: '/ecred/como-funciona-credito-on-line',
          key: 'como-funciona-credito-on-line',
          label: 'Como funciona'
        },
        {
          label: 'Empréstimo',
          key: 'emprestimo',
          withIconMenu: true,
          items: menusPersonalLoan,
        },

        {
          label: 'Cartão',
          key: 'cartao',
          withIconMenu: true,
          items: menusCreditCard,
        },
        {
          url: '/ecred/parceiros',
          key: 'partners',
          label: 'Parceiros'
        },
        {
          url: '/ecred/como-funciona-o-ecred',
          key: 'como-funciona-o-ecred',
          label: 'O eCred'
        },
        {
          label: 'Ajuda',
          key: 'ajuda',
          withIconMenu: true,
          items: [
            {
              url: '/ecred/canais-de-atendimento',
              key: 'canais-de-atendimento',
              label: 'Canais de atendimento'
            },

            {
              url: '/ecred/por-que-meu-credito-foi-negado',
              key: 'por-que-meu-credito-foi-negado',
              label: 'Por que meu crédito foi negado?'
            },
            {
              url: '/ecred/faq',
              key: 'faq',
              label: 'Tire suas dúvidas'
            }
          ]
        }
      ],
      brand: {
        path: process.env.ECS_APP_BASENAME,
        logo: {
          default: images['ecred'].logo,
          negative: images['ecred'].logoWhite
        },
        callback: () => (window.location.href = process.env.ECS_APP_BASENAME)
      },
      login: {
        path: `/entrar?${REDIRECT_URL}`
      },
      signUp: {
        path: `/cadastrar?${REDIRECT_URL}`
      },
      config: {
        color: '#e40781',
        background: pages ? '#e40781' : 'transparent',
        backgroundInScroll: '#e40781'
      }
    },
    document.getElementById('heimdall')
  );
}



// WEBPACK FOOTER //
// ./src/partials/header/header.js